"use client";

import { c as _c } from "react/compiler-runtime";
import type { MouseEvent } from "react";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { Mail, MapPin, Phone } from "lucide-react";
import { useTranslation } from "react-i18next";
import { CONTACT_INFO, CONTACT_LINKS } from "@/shared/config/contact";
function smoothScroll(e: MouseEvent<HTMLAnchorElement>) {
  const href = e.currentTarget.getAttribute("href");
  if (!href?.startsWith("#")) return;
  const el = document.getElementById(href.slice(1));
  if (el) {
    e.preventDefault();
    el.scrollIntoView({
      behavior: "smooth"
    });
  }
}
export function LandingFooter() {
  const $ = _c(74);
  const {
    t
  } = useTranslation();
  const pathname = usePathname();
  const localePrefix = pathname.startsWith("/ru") ? "/ru" : pathname.startsWith("/en") ? "/en" : "";
  let t0;
  if ($[0] !== t) {
    t0 = t("landing.nav.platform");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      href: "#features",
      label: t0
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = `${localePrefix}/how-it-works`;
  let t3;
  if ($[4] !== t) {
    t3 = t("landing.hero.ctaSecondary");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = {
      href: t2,
      label: t3,
      external: true
    };
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("landing.footer.privacy");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = {
      href: "/privacy",
      label: t5,
      external: true
    };
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("landing.footer.accountDeletion");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = {
      href: "/account-deletion",
      label: t7,
      external: true
    };
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t("landing.nav.activity");
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = {
      href: "#activity",
      label: t9
    };
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t("landing.nav.login");
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11) {
    t12 = {
      href: "/auth/login",
      label: t11,
      external: true
    };
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t1 || $[26] !== t10 || $[27] !== t12 || $[28] !== t4 || $[29] !== t6 || $[30] !== t8) {
    t13 = [t1, t4, t6, t8, t10, t12];
    $[25] = t1;
    $[26] = t10;
    $[27] = t12;
    $[28] = t4;
    $[29] = t6;
    $[30] = t8;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  const quickLinks = t13;
  let t14;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = [{
      icon: Mail,
      label: CONTACT_INFO.email,
      href: CONTACT_LINKS.email
    }, {
      icon: Phone,
      label: CONTACT_INFO.phone,
      href: CONTACT_LINKS.phone
    }, {
      icon: MapPin,
      label: CONTACT_INFO.address,
      href: null
    }];
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  const contacts = t14;
  let t15;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Link href="/" className="flex items-center gap-2"><Image src="/images/logo.svg" alt="PharmaLogic" width={32} height={32} className="size-8 rounded-md" /><span className="text-base font-semibold text-slate-900">PharmaLogic</span></Link>;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t) {
    t16 = t("landing.footer.tagline");
    $[34] = t;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t16) {
    t17 = <div className="flex flex-col gap-3">{t15}<p className="max-w-xs text-sm text-slate-500">{t16}</p></div>;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t) {
    t18 = t("landing.footer.quickLinks");
    $[38] = t;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t18) {
    t19 = <h3 className="text-sm font-semibold tracking-wide text-slate-900 uppercase">{t18}</h3>;
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== quickLinks) {
    t20 = <ul className="flex flex-col gap-2">{quickLinks.map(_temp)}</ul>;
    $[42] = quickLinks;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== t19 || $[45] !== t20) {
    t21 = <div className="flex flex-col gap-3">{t19}{t20}</div>;
    $[44] = t19;
    $[45] = t20;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== t) {
    t22 = t("landing.footer.contact");
    $[47] = t;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== t22) {
    t23 = <h3 className="text-sm font-semibold tracking-wide text-slate-900 uppercase">{t22}</h3>;
    $[49] = t22;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <ul className="flex flex-col gap-2">{contacts.map(_temp2)}</ul>;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] !== t23) {
    t25 = <div className="flex flex-col gap-3">{t23}{t24}</div>;
    $[52] = t23;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  let t26;
  if ($[54] !== t17 || $[55] !== t21 || $[56] !== t25) {
    t26 = <div className="mx-auto max-w-7xl px-6 py-12"><div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-3">{t17}{t21}{t25}</div></div>;
    $[54] = t17;
    $[55] = t21;
    $[56] = t25;
    $[57] = t26;
  } else {
    t26 = $[57];
  }
  let t27;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = new Date().getFullYear();
    $[58] = t27;
  } else {
    t27 = $[58];
  }
  let t28;
  if ($[59] !== t) {
    t28 = t("landing.footer.rights");
    $[59] = t;
    $[60] = t28;
  } else {
    t28 = $[60];
  }
  let t29;
  if ($[61] !== t28) {
    t29 = <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs text-slate-500"><p>© {t27} PharmaLogic. {t28}</p></div>;
    $[61] = t28;
    $[62] = t29;
  } else {
    t29 = $[62];
  }
  let t30;
  if ($[63] !== t) {
    t30 = t("landing.footer.poweredBy");
    $[63] = t;
    $[64] = t30;
  } else {
    t30 = $[64];
  }
  let t31;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <a href="https://banerma.uz" target="_blank" rel="noopener noreferrer" className="inline-flex min-h-11 items-center font-semibold text-teal-600 transition-colors hover:text-teal-700 focus-visible:ring-2 focus-visible:ring-teal-500/40 focus-visible:outline-none sm:min-h-0">Banerma</a>;
    $[65] = t31;
  } else {
    t31 = $[65];
  }
  let t32;
  if ($[66] !== t30) {
    t32 = <p className="text-xs font-medium text-slate-500">{t30}{" "}{t31}</p>;
    $[66] = t30;
    $[67] = t32;
  } else {
    t32 = $[67];
  }
  let t33;
  if ($[68] !== t29 || $[69] !== t32) {
    t33 = <div className="border-t border-slate-100"><div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-6 py-5 sm:flex-row">{t29}{t32}</div></div>;
    $[68] = t29;
    $[69] = t32;
    $[70] = t33;
  } else {
    t33 = $[70];
  }
  let t34;
  if ($[71] !== t26 || $[72] !== t33) {
    t34 = <footer className="border-t border-slate-100 bg-white">{t26}{t33}</footer>;
    $[71] = t26;
    $[72] = t33;
    $[73] = t34;
  } else {
    t34 = $[73];
  }
  return t34;
}
function _temp2(item) {
  const Icon = item.icon;
  const content = <span className="flex min-h-11 items-center gap-2 py-2 text-sm text-slate-500 transition-colors hover:text-slate-900 sm:min-h-0 sm:py-0"><Icon className="size-4 text-slate-400" />{item.label}</span>;
  return <li key={item.label}>{item.href ? <a href={item.href} className="inline-flex focus-visible:ring-2 focus-visible:ring-teal-500/40 focus-visible:outline-none">{content}</a> : content}</li>;
}
function _temp(link) {
  return link.external ? <li key={link.href}><Link href={link.href} className="inline-flex min-h-11 items-center py-2 text-sm text-slate-500 transition-colors hover:text-slate-900 focus-visible:ring-2 focus-visible:ring-teal-500/40 focus-visible:outline-none sm:min-h-0 sm:py-0">{link.label}</Link></li> : <li key={link.href}><a href={link.href} onClick={smoothScroll} className="inline-flex min-h-11 items-center py-2 text-sm text-slate-500 transition-colors hover:text-slate-900 focus-visible:ring-2 focus-visible:ring-teal-500/40 focus-visible:outline-none sm:min-h-0 sm:py-0">{link.label}</a></li>;
}